import React, { useContext, useEffect, useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { useForm, Controller } from 'react-hook-form';
import '../../../../App.css';
import { styled } from '../../../../components/styled';
import SpText from '../../../../components/atoms/SpText';
import SpButton from '../../../../components/atoms/SpButton';
import { SpTable, SpTableCell, SpTableRow } from '../../../../components/bundles/SpTable';
import moment from 'moment';
import { Button as MuiButton, FormControlLabel, Grid, Radio, TableCell } from '@material-ui/core';
import { withSnackbar } from '../../../../components/atoms/SpSnackBar';
import { findRentsByStationId, getRentTotal } from '../../../../models/actions/Rents';
import { isMobile } from 'react-device-detect';
import SpSearch from '../../../../components/atoms/SpSearch';
import { UserSessionContext } from '../../../../App';

const TitleToolbarSection = styled('div')({
  display: 'flex',
  flex: 1,
  alignItems: 'center',
  justifyContent: 'flex-start'
});

const StationsUsers = (props) => {
  const [rentsList, setRentsList] = useState([]);
  const [searchString, setSearchString] = useState();
  const [displayRentsList, setDisplayRentsList] = useState([]);
  const { stationId } = useParams();
  const history = useHistory();
  const { setDialogUserPNOpen, setDialogEndRent, setSelectedRentDetailOpen, setRentConfirmationOpen } = props;

  const { register, control, error, getValues, setValue, handleSubmit, reset } = useForm({
    shouldUnregister: false,
    name: 'station'
  });

  const { authData, setAuthData } = useContext(UserSessionContext);

  const fetchData = async () => {
    if (stationId) {
      try {
        const response = await findRentsByStationId({ id_station: stationId }, authData.accessToken);
        if (response) {
          setRentsList(response);
          setDisplayRentsList(response);
        }
      } catch (error) {
        props.snackbarShowErrorMessage(error);
      }
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  //FUnzioni per la dialog di chiusura del noleggio
  const getRentTotalAmountToPay = async (rent_data) => {
    const resultsRentTotal = await getRentTotal({ rent_data: rent_data }, authData.accessToken);
    if (resultsRentTotal) {
      return resultsRentTotal;
    }
  };

  const handleOpenConfirmDialog = async ({ rent, status }) => {
    try {
      const currentRent = rent;
      const { totalAmount } = await getRentTotalAmountToPay(currentRent, authData.accessToken);
      currentRent.rent_amount = totalAmount;
      if (currentRent.rent_amount == null) {
        props.snackbarShowErrorMessage(`C'è stato un errore nel calolo del totale del noleggio`);
      } else {
        setRentConfirmationOpen({ rent: currentRent, status: true });
      }
    } catch (error) {
      props.snackbarShowErrorMessage(`C'è stato un errore nella conferma del noleggio!`);
    }
  };

  const filterStations = (e) => {
    let newDisplayFilters = rentsList?.filter((row) => {
      const userNameString = row.user.email.trim().toLowerCase();
      if (userNameString.includes(e.currentTarget.value.toString().trim().toLowerCase())) {
        return row;
      }
    });
    setDisplayRentsList(newDisplayFilters);
    if (e.currentTarget.value === '') setDisplayRentsList(rentsList);
    setSearchString(e.currentTarget.value);
  };

  const headCells = [
    {
      id: 'station',
      numeric: false,
      disablePadding: false,
      label: 'Codice bicicletta',
      isAction: false
    },
    {
      id: 'data inizio',
      numeric: false,
      disablePadding: false,
      label: 'Data inizio',
      isAction: false
    },
    {
      id: 'data fine',
      numeric: false,
      disablePadding: false,
      label: 'Data fine',
      isAction: false
    },
    {
      id: 'email',
      numeric: false,
      disablePadding: false,
      label: 'Email utente',
      isAction: false
    },
    {
      id: 'station',
      numeric: false,
      disablePadding: false,
      label: 'Stazione prelievo',
      isAction: false
    },
    {
      id: 'status',
      numeric: false,
      disablePadding: false,
      label: 'Stato',
      isAction: false
    },
    {
      id: 'azioni',
      numeric: false,
      disablePadding: false,
      label: '',
      isAction: true
    }
  ];
  //rendering the profile editing form
  const RentRow = ({ row, rowKey, index, handleSelectedClick }) => {
    return (
      <SpTableRow
        role="checkbox"
        id={row?.id}
        tabIndex={index}
      >
        <SpTableCell>
          <SpText variant="tableText">{row.bike?.code}</SpText>
        </SpTableCell>
        <SpTableCell>
          <SpText variant="tableText">{row.rent.start_date && moment(row.rent.start_date).format('DD/MM/yyyy hh:mm')}</SpText>
        </SpTableCell>
        <SpTableCell>
          <SpText variant="tableText">{row.rent.end_date && moment(row.rent.end_date).format('DD/MM/yyyy hh:mm')}</SpText>
        </SpTableCell>
        <SpTableCell>
          <SpText variant="tableText">{row.user?.email}</SpText>
        </SpTableCell>
        <SpTableCell>
          <SpText variant="tableText">{row.station?.client_id}</SpText>
        </SpTableCell>
        <SpTableCell>
          <SpText variant="tableText">{row.rent?.status}</SpText>
        </SpTableCell>
        <TableCell
          align={'left'}
          style={{
            padding: 0,
            verticalAlign: 'center',
            borderBottom: 0
          }}
        >
          <SpButton
            text="Vedi"
            variant={'tableAction'}
            onClick={() => setSelectedRentDetailOpen({ rent: row, status: true })}
          />
        </TableCell>
      </SpTableRow>
    );
  };

  return (
    <div style={{ padding: 8 }}>
      <SpSearch
        onChange={(e) => filterStations(e)}
        value={searchString}
        searchStyle={{ width: '30%', color: 'white' }}
        style={{ marginRight: '5px' }}
      />
      <SpTable
        pagination={true}
        headCells={headCells}
        rows={displayRentsList}
        rowKey="id"
        padding={false}
        notCheckable={false}
        tableContainerMaxHeight={isMobile ? 'calc(100vh - 300px)' : 'calc(100vh - 320px)'}
      >
        <RentRow />
      </SpTable>
    </div>
  );
};

export default withSnackbar(StationsUsers);
